import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { StyleSheet, View, Platform } from 'react-native'

type NormalizedPosition = {
  top: number,
  left: number,
  width: number,
  height: number,
}

type Props = {
  /** Only used to detect changes to the image. */
  sku: string,
  /** The offsets and width / height of the source image to draw in the destination canvas. */
  normalizedPosition: NormalizedPosition, 
  /** The React ref to the image we want to draw. */
  imgRef: React.RefObject<HTMLImageElement>
}

export const ZoomedImage = ({sku, normalizedPosition, imgRef}: Props) => {
  const [canvasSize, setCanvasSize] = React.useState({width: 0, height: 0})
  const containerRef = React.useRef<View>()

  React.useEffect(() => {
    (async () => {
      if (imgRef?.current) {
        const canvas = document.querySelector('#zoomed-image-canvas')! as HTMLCanvasElement
        imgRef.current.id = 'image_ref_current'
        const imgElement = document.querySelector('#image_ref_current img') as HTMLImageElement

        if (imgElement) {
          try {

            const ctx = canvas.getContext('2d')
  
            if (ctx) {
              ctx.drawImage(imgElement as CanvasImageSource,
                imgElement.naturalWidth * normalizedPosition.left,
                imgElement.naturalHeight * normalizedPosition.top,
                imgElement.naturalWidth * normalizedPosition.width, 
                imgElement.naturalHeight * normalizedPosition.height, 
                (canvasSize.width - (canvasSize.height * 0.8)) / 2, 
                0, 
                canvasSize.height * 0.8, 
                canvasSize.height
              )
            }
          } catch(error) {
            console.log({error})
          }
        }
       
      }
    })()
  })

  React.useEffect(() => {

    if (containerRef.current) {
      const domNode = ReactDOM.findDOMNode(containerRef.current)
      if (domNode) {
        const width = parseInt(getComputedStyle(domNode as Element).getPropertyValue('width'))
        const height = parseInt(getComputedStyle(domNode as Element).getPropertyValue('height'))
        setCanvasSize({width, height})  
      }
    }
  }, [containerRef.current, imgRef.current])

  return (
    <View
      style={styles.container}
      ref={containerRef as React.RefObject<View>}
    >
      <canvas
        id="zoomed-image-canvas"
        height={canvasSize.height}
        width={canvasSize.width}
      >
      </canvas>
    </View>
  )
}

ZoomedImage.propTypes = {
  sku: PropTypes.string.isRequired,
  normalizedPosition: PropTypes.object.isRequired,
  imgRef: PropTypes.object.isRequired,
}

const styles = Platform.OS === 'web' ? StyleSheet.create({
  container: {
    width: '48vw',
    height: '95%',
    opacity: 1,
    // Use type any to silence error about using fixed in react native.
    // This component is only ever ran when Platform.OS === 'web'
    position: 'fixed' as any,
    top: '2.55%',
    right: '1vw',
    zIndex: 100,
    backgroundColor: 'white',
    boxShadow: '2px 2px 10px gray'
  }
  }) : StyleSheet.create({
      container: {
        width: '48vw',
        height: '95%',
        opacity: 1,
        top: '2.55%',
        right: '1vw',
        zIndex: 100,
        backgroundColor: 'white',
      }
  })
